// extracted by mini-css-extract-plugin
export default {"wrapper":"DesktopMenu_wrapper__YYsWr","step":"DesktopMenu_step__7+k6T"};